import { useMemo, useState } from 'react'

import { TableContext } from './TableContext'
import Table from './TableCore'
import type {
  ColumnType,
  ITablesExtendsData,
  PaginationConfig,
  ResizeData,
  SortConfig,
  TableProps,
} from './types'

interface IModalTableProps<T extends ITablesExtendsData> extends TableProps<T> {
  paginationConfig: PaginationConfig
  sortConfig: SortConfig
}

const ModalTable = <T extends ITablesExtendsData>(props: IModalTableProps<T>) => {
  const { paginationConfig, sortConfig, columns: baseColumns } = props
  const [columns, setColumns] = useState<ColumnType<T>[]>(baseColumns)

  const handleResize = (index: number, data: ResizeData) => {
    const next = [...columns]
    const col = { ...next[index] }
    col.width = data.width
    next[index] = col
    setColumns(next)
  }

  const value = useMemo(
    () => ({
      pagination: paginationConfig,
      sort: sortConfig,
    }),
    [paginationConfig, sortConfig],
  )

  return (
    <TableContext.Provider value={value}>
      <Table {...props} columns={columns} onColumnResize={handleResize} />
    </TableContext.Provider>
  )
}

export default ModalTable
